export default {
  loanFormFields: {},
  enquiryFormFields: {},
  enquiryFormSections: {},
  grantFormFields: {}, // australia
  equityFormFields: {} // australia
}
